import { MarketAPI } from "../api";

export class Market {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }

  static async getMarketByProject(payload, user) {
    const { data } = await MarketAPI.getMarketByProject(payload, user);
    return data.result.map(item => new Market(item));
  }
  // static async updateImageBase64(payload) {
  //   const { data } = await MarketAPI.updateImageBase64(payload);
  //   return data.result;
  // }
}
